import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Delete Empty"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-delete-empty',
    templateUrl: './icon-delete-empty.component.html',
    styleUrls: ['./icon-delete-empty.component.scss'],
    standalone: false
})
export class IconDeleteEmptyComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
